import { render, staticRenderFns } from "./ExpartiateCost.vue?vue&type=template&id=2e71b7ec&scoped=true"
import script from "./ExpartiateCost.vue?vue&type=script&lang=js"
export * from "./ExpartiateCost.vue?vue&type=script&lang=js"
import style0 from "./ExpartiateCost.vue?vue&type=style&index=0&id=2e71b7ec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e71b7ec",
  null
  
)

export default component.exports